import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";
import { MaintenanceWorkOrder } from "@/models/MaintenanceWorkOrder";
import { MaintenanceWorkOrderJob } from "@/models/MaintenanceWorkOrderJob";

export default function combineMaintenanceData(
  workOrders: MaintenanceWorkOrder[], // Just for the user that openend it
  workOrderJobs: MaintenanceWorkOrderJob[], // Where all the data about the job is
): MaintenanceDisplayData[] {
  return workOrderJobs.flatMap(workOrderJob => {
    const workOrder = workOrders.find(wo => wo?.id === workOrderJob?.workOrder?.id);
    return [
      {
        id: workOrderJob.id,
        device: workOrderJob.device,
        source: workOrderJob.maintenanceType.source,
        openedBy: workOrder?.openedByUser,
        createdAt: workOrderJob.dateTime,
        workOrderJob: workOrderJob,
        statusCode: workOrderJob.statusCode,
        updatedAt: workOrderJob.updateDate,
        reference: workOrderJob.reference,
      } as MaintenanceDisplayData,
    ];
  });
}
